<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { reactive, defineProps, defineEmits, watch, ref } from 'vue';
    import { QuillEditor } from '@vueup/vue-quill'
    import { AMOUNT_FORMAT_CONFIG, INTEGER_FORMAT_CONFIG } from '@/utils';
    // @ts-expect-error raison: lib externe mal typée
    import Vue3TagsInput from 'vue3-tags-input';

    const props = defineProps({
        modelValue: { type: Object, default: null },
        startupFormDatas: { type: Object, required: true },
        id: { type: Number, default: null },
    });
    const emit = defineEmits(['update:modelValue']);

    const formData = ref({
        categorie_ids: [] as any[],
        sku: "",
        ean: "",
        nom: "",
        description: "",
        montant: 0,
        metadata: [] as any[],
        fournisseurs_ids: [] as any[],
        quantite: 0,
    });
    const errors = reactive({
        categorie_ids: "",
        sku: "",
        ean: "",
        nom: "",
        montant: "",
    });

    watch(
        () => props.modelValue,
        (newVal) => {
            if (newVal) { Object.assign(formData.value, newVal); }
        }, { immediate: true, deep: true }
    );

    watch(
        formData,
        (newVal) => { emit('update:modelValue', { ...newVal }) },
        { deep: true }
    );
    function handleChangeTag(newTags: any) {
        formData.value.metadata = newTags;
    }
</script>

<template>
    <div>
        <div class="form-field-floating full my-5">
            <select class="form-input-select" v-model="formData.categorie_ids" name="categorie_ids" id="categorie_ids" multiple="true" size="1">
                <option :value="categorie.id" v-for="(categorie, index) in startupFormDatas.categories" :key="'categorie_' + index">
                    {{ categorie.nom }}
                </option>
            </select>
            <label for="categorie_ids">Catégories <b class="color-danger">*</b></label>
        </div>

        <div class="form-field-floating reactive active my-4">
            <input type="text" class="form-input" v-model="formData.sku" name="sku" id="sku" placeholder="" autocomplete="off">
            <label for="sku">SKU <b class="color-danger">*</b></label>
        </div>
        <span v-if="!!errors['sku']" class="text-red">{{ errors['sku'] }}</span>

        <div class="form-field-floating reactive active my-4">
            <input type="text" class="form-input" v-model="formData.ean" name="ean" id="ean" placeholder="" autocomplete="off">
            <label for="ean">EAN (codes barres)</label>
        </div>
        <span v-if="!!errors['ean']" class="text-red">{{ errors['ean'] }}</span>

        <div class="form-field-floating reactive active my-4">
            <input type="text" class="form-input" v-model="formData.nom" name="nom" id="nom" placeholder="" autocomplete="off">
            <label for="nom">Désignation <b class="color-danger">*</b></label>
        </div>
        <span v-if="!!errors['nom']" class="text-red">{{ errors['nom'] }}</span>

        <div class="form-field-floating reactive active my-4">
            <money3 class="form-input" v-model="formData.montant" name="montant" id="montant" placeholder="" v-bind="AMOUNT_FORMAT_CONFIG"></money3>
            <label for="montant">Prix unitaire <b class="color-danger">*</b></label>
        </div>
        <span v-if="!!errors['montant']" class="text-red">{{ errors['montant'] }}</span>

        <div class="form-field-floating reactive active my-4">
            <money3 class="form-input" v-model="formData.quantite" name="quantite" id="quantite" placeholder="" v-bind="INTEGER_FORMAT_CONFIG" :readonly="props.id != null"></money3>
            <label for="quantite">Stock initial</label>
        </div>

        <div class="form-field-floating full my-5">
            <select class="form-input-select" v-model="formData.fournisseurs_ids" name="fournisseurs_ids" id="fournisseurs_ids" multiple="true" size="1">
                <option :value="fournisseur.id" v-for="(fournisseur, index) in startupFormDatas.fournisseurs" :key="'fournisseur_' + index">
                    {{ fournisseur.nom_fournisseur }}
                </option>
            </select>
            <label for="fournisseurs_ids">Fournisseurs</label>
        </div>

        <div>
            <div class="my-4">
                <label for="nom">Mots clés</label>
                <vue3-tags-input placeholder="Saisir les mots clés" @on-tags-changed="handleChangeTag" :tags="formData.metadata" />
            </div>
        </div>

        <div>
            <QuillEditor id="description" placeholder="Description" v-model:content="formData.description" contentType="html" theme="snow" style="height: 300px" />
        </div>
    </div>
</template>
